import React from 'react'
import accounting from 'accounting';
import axios from 'axios'

import { withRouter } from 'react-router-dom'

import GenericSearchTable from '../generics/search-table'

import {
    Card,
    Dropdown,
    Menu,
    Upload,
    message,
    Icon,
    Divider,
    Input
} from 'antd'

import {
    _getRefunds
} from '../../services'
import moment from 'moment'
import { URL_ENDPOINT } from '../..'


class Refunds extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            bankref: ''
        }
    }

    render(){

        const defaultValue = this.props.match.params.searchParam

        var columns = [{
            title: 'Entity Type',
            dataIndex: 'entityType'
        },{
            title: 'Entity Id',
            dataIndex: 'entityId'
        },{
            title: 'Ref No.',
            dataIndex: 'cartRefNumber'
        },{
            title: "Refund Date",
            dataIndex: 'dateOfRefund',
            render:( dateOfRefund ) => {
                return moment(dateOfRefund).format("YYYY-MM-DD")
            }
        },{
            title: 'Currency',
            dataIndex: 'currency'
        },{
            title: 'Amount',
            dataIndex: 'amount',
            render: (amount) => accounting.formatMoney( amount, '$', 2)
        },{
            title: "Proof",
            render: (refund) => this.renderUploadButton(refund)
        }]

        return (
            <Card title="Refunds">
                <GenericSearchTable
                    defaultValue={defaultValue}
                    placeholder="Search Inv No. or Ref No."
                    request={_getRefunds}
                    columns={columns}
                />
            </Card>
        )
    }

    renderUploadButton = (refund) => {
        console.log(this.state.bankref)
        return (
            <div>
                <Upload
                    name="file"
                    action={`${URL_ENDPOINT}/api/admin/order-docs/upload-refund/${refund._id}`}
                    data={{
                        bankref: JSON.stringify(this.state.bankref)
                    }}
                    onChange={(info) => {

                        const status = info.file.status;
                        if (status !== 'uploading') { }
                        if (status === 'done') {

                            message.success('File upload success')

                        } else if (status === 'error') {
                            message.error(`File upload failed.`);
                        }

                    }}
                    withCredentials>
                    <a>
                        Upload {refund.uploadedProof && <span style={{ color: 'rgba(0,0,0,0.65)' }}> [Existing Upload]</span>}
                    </a>
                </Upload>
                {this.renderTextInput(refund)}
            </div>
        )
    }

    
    renderTextInput = (refund) => {

        // Only render for entityType == corpbilling
        if (refund.entityType != 'corpbilling') { 
            return null
        }

        // Only render if no uploadedProof yet i.e not verified
        if (refund.uploadedProof) {
            return null
        }

        return (
            <Input 
                placeholder="Reference Text for Bank Txn"
                width={300}
                onChange={(e => this.setState({ bankref: e.target.value }))}
                />
        )
    }

    handleSend = (refund) => {

        message.loading("Sending")

        axios.get(`${URL_ENDPOINT}/api/admin/refunds/send/${refund.cart.refNumber}`, {
            withCredentials: true
        })
        .then(() => {
            message.destroy()
            message.success("Refund receipt sent!")
        })
        .catch(() => {
            message.destroy()
            message.error("Error")
        })

    }
}

export default withRouter(Refunds)


// WEBPACK FOOTER //
// ./src/components/refunds/index.js